export class AdjustmentEffectivenessErrorResponse {
  adjustmentEffectiveness: any;
}
